require('../../../modules/es.array.sort');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').sort;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/sort.js
// module id = 981
// module chunks = 0